"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Snap to one slide if snapping is active so the slide is fully visible
 * @param newPosXValue posXValue that should be changed
 * @param snapping is snapping activated in snappingProp?
 * @param variableWidth is variableWidth  activated in variableWidthProp?
 * @param virtualMaxScrollPosRight how far can the track be scrolled. Important because otherwise it's possible that the track will always snap to a slide on the left but won't show the last item on the right completely
 * @param slideWidth width of a slide
 */
var considerSnapping = function (newPosXValue, snapping, variableWidth, virtualMaxScrollPosRight, slideWidth) {
    if (snapping &&
        !variableWidth &&
        Math.round(newPosXValue) !== Math.round(virtualMaxScrollPosRight)) {
        var delta = -newPosXValue % slideWidth;
        return (delta < slideWidth / 2 ? newPosXValue : newPosXValue - slideWidth) + delta;
    }
    return newPosXValue;
};
exports.default = considerSnapping;
//# sourceMappingURL=considerSnapping.js.map